import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { getPageUrl } from "utils/getPageUrl";
import { CTA } from "components";
import type { CTAProps } from "./CTA.d";

const CTAMagnitudeAdapter = ({ props: [text, buttonText] }: CTAProps) => {
  const translations = useTranslations();
  const language = useLanguage();
  const buttonHref = getPageUrl(language, "webappNewClaim");

  return (
    <CTA
      text={text}
      buttonText={buttonText}
      buttonHref={buttonHref}
      checkboxes={[translations("all_airlines"), translations("all_countries"), translations("no_win_no_fee")]}
    />
  );
};

export default CTAMagnitudeAdapter;
